export const inputPlaceholder = 'type to search';
export const emptyInput = 'Please enter a name to search';
export const fetchMsg = 'Finding events…';
export const helpText = 'Search by first names, last names, or event handle.';

export const findACouplePageData = {
  seo: {
    title: 'Find an Event’s Website and Registry - Joy',
    content: 'Find an event’s registry or website using Joy’s event search.',
    url: 'https://withjoy.com/find/',
  },
  heroSection: {
    website: 'Website',
    registry: 'Registry',
    findAnEvent: 'Find an Event',
    searchNote: 'Search by first names, last names, or event handle.',
    searchPlaceholder: 'Type to search...',
    suggestions: {
      tryUsing: 'Try using...',
      bothNames: 'Both first and last names',
      properNames: 'Proper names, like Rebekah for Bekah',
      nicknames: 'Nicknames, like Tom for Thomas',
      eventHandle: 'Their exact event handle, such as “Carrie’s Registry”',
      note:
        'Still having trouble? Note that some hosts may have opted to be hidden from search results. Please check your invite for the link or event handle.',
    },
    showAllCta: 'Show All',
    fetchMsg: 'Finding events…',
    emptyInput: 'Please enter a name to search',
    eventFoundMsg: '1 Event found',
    eventsFoundMsg: 'Events found',
    moreEventsFoundMsg: '50+ Events found',
    eventsNotFoundMsg: 'We couldn’t find',
  },
  blogTitle: 'How to Be the Best Guest.',
} as const;

export const findAnEventPageData = {
  celebratingCouple: {
    title: 'Celebrating with over a million just like you.',
  },
  navigationSection: {
    title: 'Joy is Changing Event Planning Forever.',
  },
  brandSection: {
    title: '“With its massive list of features and intuitive design, Joy is a one-stop shop for organizing every single event detail.”',
  },
};
